import { useState, useEffect } from "react";
import "../../Style.css";
import Utils from "../../core/Utils";
import UserHelper from "../../core/UserHelper";
import { connectToStore } from "../../data/store";
import SideBarMenuItems from "../SideBarMenuItems";
import ReportMenuItems from "../ReportMenuItems";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import {
  SideBarMenuNames,
  SettingsMenuList,
  ReportMaxDateLimit,
  UserRoles,
} from "../../core/Constants";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MessagePopup from "../common/MessagePopUp";
import "react-calendar/dist/Calendar.css";
import { Grid, Box, Container, Stack } from "@mui/material";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import Loader from "../common/Loader";
import moment from "moment";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { LoginPage, VendorLedgerReportPage } from "../../core/PageConstants";
import InputLabel from "@mui/material/InputLabel";
import { getBusiness, getCountry } from "../../data/localSettingsActions";
import { postAsync } from "../../core/serviceClient";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CountryHelper from "../../core/CountryHelper";
import ClearIcon from '@mui/icons-material/Clear';
import AssessmentIcon from '@mui/icons-material/Assessment';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const VendorLedgerReport = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [reportContent, setReportContent] = useState("");
  const [filterByVendor, setfilterByVendor] = useState(false);
  const [filterByTechBranch, setFilterByTechBranch] = useState(false);
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [statementMethod, setStatementMethod] = useState("Summary");
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [selectedTechBranch, setSelectedTechBranch] = useState("");
  const [techBranches, setTechBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [allTechnicians, setAllTechnicians] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
  };

  const handleSubmit = () => {

    getStatementStatus(statementMethod);
  };

  const getStatementStatus = async () => {
    if (Utils.IsNullOrEmptyArray(selectedVendor)) {
      setMsgText(
        "Please select the Vendor"
      );
      setMsgOpen(true);
      return;
    }
    setIsLoading(true);
    let url = "reports/GetLedgerReport?";
    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      localSettings.branch.branchId +
      "&businessId=" +
      localSettings.business.id +
      "&vendorId=" +
      selectedVendor +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&token=" +
      localSettings.token +
      "&token=" +
      localSettings.token +
      "&isDownloadVisible=" +
      true;
    window.open(reportUrl, "_blank");

    setIsLoading(false);
  };

  const handleShowReport = (e) => {
    e.preventDefault();
    setReportContent('')
    if (Utils.IsNullOrEmptyArray(selectedVendor)) {
      setMsgText(
        "Please select the Vendor"
      );
      setMsgOpen(true);
      return;
    }
    setIsLoading(true);
    let url = "reports/GetLedgerReport?";
    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      localSettings.branch.branchId +
      "&businessId=" +
      localSettings.business.id +
      "&vendorId=" +
      selectedVendor +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&token=" +
      localSettings.token +
      "&token=" +
      localSettings.token +
      "&isDownloadVisible=" +
      true +
      "&_ts=" + new Date().getTime();
    setReportContent(reportUrl);
  };

  const checkAuthentication = () => {
    if (
      UserHelper.CheckPermission(VendorLedgerReportPage, navigate, localSettings)
    ) {
      const business = getBusiness();
      if (
        !Utils.IsNullOrEmptyObject(business) &&
        !Utils.IsNullOrEmptyArray(business.branchLocations)
      ) {
        setBranches(business.branchLocations);
      }
      getVendorDetails();
    }
  };
  useEffect(() => {
    checkAuthentication();
  }, []);

  const handleSelect = (event) => {
    setSelectedVendor(event.target.value);
  };


  const getVendorDetails = async () => {
    if (localSettings.authenticated) {
      setIsLoading(true);
      let result = await postAsync(
        "Vendor/GetVendorDetails",
        {},
        "",
        "GetAll",
        "GetAllVendorDetailsByBusiness",
        [localSettings.business.id]
      );
      if (result.error) {
        setMsgOpen(true);
        setMsgText(result.errorMessage);
      } else {
        if (!Utils.IsNullOrEmptyArray(result.data)) {
          setVendorList(
            (result?.data || []).filter(v => v.vendorStatus === true)
          );
        }
      }
      setIsLoading(false);
    }
  };


  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText(
          "Please select a valid date range."
        );
        setMsgOpen(true);
      }
      else {
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateDiff > ReportMaxDateLimit) {
          setMsgText(
            "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
          );

          setMsgOpen(true);
        } else {
          setSelectedDate(dateArray);
        }
      }
    }
  };

  const handleLabelClear = (event) => {
    setSelectedVendor(""); // Set the value to an empty string to clear the selection
    setSelectedVendor(event.target.value);
  }

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />

        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.InvoiceReport} />
            <Grid xs={12} className="content-sec">
              <Grid container direction="row" className="">
                <ReportMenuItems
                  selectedMenu={SettingsMenuList.BusinessReports.VendorLedgerReport}
                />
                <Grid xs={12} md={9}>
                  <Grid spacing={2} className="form-sec">
                    <Stack
                      direction="row"
                      spacing={1}
                      className="card white-bg p-1 sticky-search-form"
                      justifyContent="space-between"
                    >
                      <FormControl
                        fullWidth
                        className="font-size-14"
                        sx={{ width: "300px" }}
                        error={!selectedVendor}>
                        <InputLabel id="vendor-label">Select Vendor</InputLabel>
                        <Select
                          labelId="vendor-label"
                          value={selectedVendor || ""}
                          onChange={handleSelect}
                          label="Select Vendor"
                          sx={{ height: 46 }}
                        >
                          {vendorList.map((vendor) => (
                            <MenuItem key={vendor.id} value={vendor.id}>
                              {vendor.vendorName}
                            </MenuItem>
                          ))}
                        </Select>
                        <Button className="clearBtn" title="Clear" onClick={handleLabelClear}><ClearIcon /></Button>
                      </FormControl>
                      <Stack
                        direction="row"
                        spacing={1}
                        style={{ height: "100%", alignItems: "center" }}
                      >
                        <DateRangePicker
                          value={selectedDate}
                          onChange={onDateChange}
                          maxDate={new Date()}
                          showLeadingZeros
                          locale={CountryHelper.GetDateCulture(
                            localSettings.country.Culture
                          )}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon sx={{ fontSize: 24, color: "#666" }} />
                          }
                          style={{ width: "100%", height: 50 }}
                        />
                        <FormControl>
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            onClick={handleShowReport}
                          >
                            <AssessmentIcon fontSize="large" /> &nbsp;
                            Show Report
                          </Button>
                        </FormControl>
                        <FormControl>
                          <Tooltip title="Open in new tab" arrow="top">
                            <Button
                              className="btn btn-secondary"
                              variant="contained"
                              onClick={handleSubmit}
                            >
                              <OpenInNewIcon fontSize="large" /> &nbsp;
                            </Button>
                          </Tooltip>
                        </FormControl>
                      </Stack>
                    </Stack>
                    <iframe
                      className="reportIframe card white-bg mt-1"
                      src={reportContent}
                      onLoad={() => setIsLoading(false)}
                      style={{
                        width: "100%",
                        height: "calc(100vh - 180px)",
                      }}
                    ></iframe>
                    <br />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid >
    </Container >
  );
};

export default VendorLedgerReport;
